import styled from "@emotion/styled";
import Icon from "metabase/components/Icon";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const IconSmall = styled(Icon)`
  margin-left: 24px;
`;
